var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.setUp === null
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.setUp
        ? _c("feature-setup", {
            attrs: {
              feature: "autoresponders"
            },
            on: {
              create: function create($event) {
                return _vm.openForm({
                  first: true
                })
              }
            }
          })
        : _vm.form.open
        ? _c("add-responder", {
            attrs: {
              edit: _vm.form.edit,
              email: _vm.form.email
            },
            on: {
              change: _vm.closeForm
            }
          })
        : _c("autoresponder-table", {
            attrs: {
              title: "Auto Replies"
            },
            on: {
              edit: _vm.openForm
            },
            scopedSlots: _vm._u([
              {
                key: "header-actions",
                fn: function fn() {
                  return [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "my-1",
                        attrs: {
                          secondary: "",
                          small: ""
                        },
                        on: {
                          click: function click($event) {
                            return _vm.openForm()
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: ""
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Create Auto Reply ")
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }